import { render, staticRenderFns } from "./Source.vue?vue&type=template&id=1a64f1a0&"
import script from "./Source.vue?vue&type=script&lang=js&"
export * from "./Source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports